<template>
  <div id="product-inventory-page" class="estore-body">
    <div class="inventory-content">
      <template v-if="product">
        <b-button
          variant="light"
          size="sm"
          class="btn-pill shadow-sm"
          :to="{ name: 'Inventory' }"
        >
          <i class="bi bi-arrow-left mr-2" aria-hidden="true"></i> Back
        </b-button>
        <div class="h4 font-weight-bold my-3">
          {{ product.product_name }}
        </div>
      </template>
      <InventoryToolbar
        ref="InventoryToolbar"
        hide-search
        show-edit-add-ons-button
        @getInventoryList="getProductInventoryList"
        @showAddOnsModal="
          $root.$emit('bv::show::modal', 'inventory-view-add-ons-modal')
        "
      />
      <InventoryDataTable
        is-inventory-by-product
        @getInventoryList="getProductInventoryList"
      />
      <InventoryPagination
        v-if="inventoryList.length"
        @getInventoryList="getProductInventoryList"
        is-inventory-by-product
      />
      <ViewAddOnsModal :product="product" />
    </div>
  </div>
</template>

<script>
import InventoryToolbar from "@/components/products/inventory/InventoryToolbar";
import InventoryDataTable from "@/components/products/inventory/InventoryDataTable";
import InventoryPagination from "@/components/products/inventory/InventoryPagination";
import ViewAddOnsModal from "@/components/products/inventory/ViewAddOnsModal";
import { mapState } from "vuex";
import { mapFields } from "vuex-map-fields";

export default {
  props: ["productId"],
  components: {
    InventoryToolbar,
    InventoryDataTable,
    InventoryPagination,
    ViewAddOnsModal,
  },
  computed: {
    ...mapState("products", ["inventoryList", "filters", "pagination"]),
    ...mapFields("products", ["isAllSelected", "selectedItems"]),
    product() {
      return this.inventoryList.length
        ? JSON.parse(JSON.stringify(this.inventoryList[0]))
        : null;
    },
  },
  methods: {
    async getProductInventoryList() {
      await this.$store.dispatch("products/getProductInventoryList", {
        page: this.pagination.currentPage ? this.pagination.currentPage : 1,
        payload: this.filters,
        productId: this.productId,
      });
    },
  },
  created() {
    this.$store.commit("products/setFilters", {
      branch_uuids: [],
    });
    this.$store.commit("products/setPagination", {});
    this.selectedItems = [];
    this.isAllSelected = false;
    this.getProductInventoryList();
  },
};
</script>

<style lang="scss">
#product-inventory-page {
  .back-button {
    display: flex;
    align-items: center;
    border: solid 1px #e9ebed;
    color: #2f3941;
    font-size: 14px;
    font-weight: bold;
    border-radius: 20px;
    box-shadow: 0.25rem 0.25rem 0.55rem rgba(0, 0, 0, 0.15);
  }
}
</style>
